import {UtilizacaoSalaModel} from '@/models/gestao/utilizacaosala/utilizacaosala.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';

class UtilizacaoSalaService {
 dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[]): Promise<AxiosResponse<DataSource<UtilizacaoSalaModel>>> {
  return api.post <DataSource <UtilizacaoSalaModel>>('/UtilizacaoSala/RetornoPaginado', {
   rowsPerPage:  itensPorPagina,
   pageNumber: pagina,
   filters: filters
  });
 }

 inserirAtualizar(utilizacaoSala: UtilizacaoSalaModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/UtilizacaoSala', utilizacaoSala);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/UtilizacaoSala/' + id);
 }

 atualizar(utilizacaoSala: UtilizacaoSalaModel): Promise<AxiosResponse> {
  return api.put('/UtilizacaoSala', utilizacaoSala);
 }

 async get(id: number): Promise<UtilizacaoSalaModel> {
  const result = await api.get<UtilizacaoSalaModel>(`/UtilizacaoSala/${id.toString()}`);
  return result.data;
 }

 async DropDownList() : Promise<TextoValor[]> {
  const endpoint = "/UtilizacaoSala/DropDownList";
  const result = await api.get(endpoint);
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new UtilizacaoSalaService();
